<template>
  <div class="container">
    <div class="row" style="min-height: 100%; min-height: 100vh;">
      <div class="col">
        <form
          @submit.prevent="logging"
          class="d-flex justify-content-center align-items-center h-100"
        >
          <div class="card az-anime-surgir" style="padding: 0px; max-width: 400px;" v-if="pronto">
            <div class="card-header">
              <img :src="logo" alt="logo" class="logo-responsive" v-if="logo && logo != '?'" />
              <img src="../assets/logo.jpeg" alt="logo" class="logo-responsive" v-else />
            </div>
            <div class="card-body" v-if="!user">
              <p class="lead text-center">{{ nome }}</p>
              <p class="lead text-center">Redefinir Senha</p>  
              <p class="lead text-center alert" :class="'alert-' + ( level == 'error' ? 'danger' : level )" v-if="msg">{{ msg }}</p>  
            </div>
            <div class="card-body" v-if="user">
              <p class="lead text-center">{{ nome }}</p>

              <div class="alert alert-warning" v-if="$route.query.r">Necessário redefinição de senha.</div>

              <div v-if="nome != '...'">

                <small class="form-text text-muted text-nowrap text-truncate">
                    Login
                </small>
                <div class="form-group">
                  <label class="form form-control bg-light">
                      {{ user.st_login }}
                  </label>
                </div>

                <div class="form-group" v-if="!tipo == 'P'">
                  <label class="form form-control">
                      {{ user.search }}
                  </label>
                </div>

                <div class="form-group">
                  <input
                    type="password"
                    class="form form-control"
                    placeholder="Senha"
                    name="login-userpassword"
                    autocomplete="false"
                    required
                    v-model="user.senha"
                  />
                </div>

                <div class="form-group mb-0">
                  <input
                    type="password"
                    class="form form-control"
                    placeholder="Confirmar Senha"
                    name="login-userpassword-confirm"
                    autocomplete="false"
                    required
                    v-model="user.confirmar_senha"
                  />
                </div>
              </div>

            </div>

            <div class="card-body" v-else-if="!tipo">
              <div class="lead text-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>

            <div class="card-footer d-flex flex-column" v-if="tipo">
              <button class="btn btn-primary" type="submit" :disabled="enviando || nome == '...'" v-if="user">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="enviando"
                ></span>
                <span v-else>Redefinir</span>
              </button>

              <div class="text-center mt-2 mb-0" v-if="tipo == 'P'">
                <a :href="link_portal" class="card-link" >Acessar Portal</a>
              </div>

              <button type="button" class="btn btn-link mt-2 mb-0" @click="$router.push({ path: '/' })" v-else>
                Acessar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <Toast />

  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "Login",
  data() {
    return {
      nome: "...",
      enviando: false,
      user: null,
      email: "",
      validate: false,
      msg: "",
      level: "", 
      tipo: "", 
      logo: "?", 
      visibility: "",
      pronto: false, 
    };
  },
  props: ['id', 'token'],
  
  computed: { 
    link_portal: function () { 
      return window.location.protocol + '//portal-' + window.location.host; 
    }
  },
  
  mounted() {
    this.axios.get("/subdomain")
      .then(res => {
        this.nome = res.data.name;
        this.logo = res.data.logo;
        this.visibility = res.data.visibility;
        this.$store.commit('setLogo', this.logo);
      })
      .finally(() => { 
        this.pronto = true;
      });

    this.axios.get('/valid_token?id=' + this.id + '&token=' + this.token)
        .then(res => { 
            if ( res.data.level == 'success' ) {
                this.tipo = res.data.usuario.st_tipo;

                this.user = { 
                    id_usuario: res.data.usuario.id_usuario, 
                    st_login: res.data.usuario.st_login, 
                    search: res.data.usuario.search,
                    token: this.token, 
                    senha: "", 
                    confirmar_senha: "", 
                    st_tipo: res.data.usuario.st_tipo, 
                };
            } else { 
                this.msg = res.data.msg;
                this.level = res.data.level;

                this.$toast.add({
                    severity: res.data.level,
                    summary: "Atenção",
                    detail: res.data.msg,
                    life: 3000
                });
            }
        });
  },
  methods: {
    cliente() {
      return window.redir;
    },
    enviar() {
      this.validate = true;

      this.$nextTick(() => {
        let invalids = $(".invalid");

        if (invalids.length) {
          //
        } else {
          this.$store.commit("loading", true);

          this.axios.post("/recuperar", { email: this.email }).then(res => {
            $(".modal").modal("hide");

            this.$toast.add({
              severity: res.data.level,
              summary: "Atenção",
              detail: res.data.msg,
              life: 3000
            });
          })
          .finally(() => { 
            this.$store.commit("loading", false);
          });
        }
      });
    },
    async logging() {
      this.enviando = true;
      this.$store.commit("loading", true);
      this.axios
        .post("redefinir", this.user)
        .then(res => {

            if ( res.data.level ) {

                this.msg = res.data.msg;
                this.level = res.data.level;
                this.user = null;

                this.$toast.add({
                    severity: res.data.level,
                    summary: "Atenção",
                    detail: res.data.msg,
                    life: 3000
                });
            }

          
        })
        .finally(() => {
            this.enviando = false;
            this.$store.commit("loading", false);
        });
    }
  }
};

//components: { AppSpinner },
</script>

<style scoped>
.logo-responsive {
  max-width: 100%;
  height: auto;
}

.az-anime-surgir {
  animation: az-surgir 1s;
}

@keyframes az-surgir {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1) ease-in-out;
  }
}
</style>
